import styled from "styled-components";
export const StyledRow = styled.tr `
  > td:first-of-type {
    > div {
      padding: ${({ tableType }) => (tableType === "TB02" ? "0rem" : "")};
    }
  }
  border: 1.5px solid transparent;
  border-top: 2px solid transparent;
  :last-child {
    ${({ focused, theme }) => focused ? `border-top: 2px solid ${theme.colors.primaryLight};` : ""}
    ${({ focused, theme }) => focused ? `border-bottom: 2px solid ${theme.colors.primaryLight};` : ""}
  }
  outline: none;
  cursor: ${({ tableType, rowType }) => (tableType === "TB02" || tableType === "TB04") && rowType === "body"
    ? "pointer"
    : "auto"};
  border-bottom: ${({ rowType, theme, tableType }) => rowType === "header" || tableType !== "TB01"
    ? `1px solid rgba(${theme.colors.transparentBlack}, 0.16)`
    : "1px solid transparent"};

  ${({ theme, checked, tableType, odd, rowType }) => rowType !== "header"
    ? tableType === "TB01" && odd
        ? `background-color: rgba(${theme.colors.transparentBlack}, 0.06)`
        : tableType === "TB02" && checked
            ? `background-color: rgb(${theme.colors.transparentBlack}, 0.04)`
            : "background: none"
    : ""};

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme, checked, tableType, rowType }) => rowType !== "header"
    ? tableType === "TB02" || tableType === "TB04"
        ? checked
            ? `rgb(${theme.colors.transparentBlack}, 0.08)`
            : `rgb(${theme.colors.transparentBlack}, 0.04)`
        : ""
    : ""};
      ${({ focused }) => (focused ? `border-bottom-color: transparent;` : "")};
      label::before {
        background-color: ${"transparent"};
      }
    }
  }

  &:focus {
    ${({ focused, theme }) => focused ? `outline: 1px solid ${theme.colors.primaryLight};` : ""}
    ${({ focused, theme }) => focused ? `border: 1px solid ${theme.colors.primaryLight};` : ""}
    ${({ focused, theme }) => focused ? `border-bottom: 2px solid ${theme.colors.primaryLight};` : ""}
    ${({ focused, theme }) => focused ? `border-top: 2px solid ${theme.colors.primaryLight};` : ""}
  }

  &:active {
    ${({ theme }) => theme.global.disableTapHighlight}

    background-color: ${({ theme, tableType, rowType }) => rowType !== "header"
    ? tableType === "TB02" || tableType === "TB04"
        ? `rgb(${theme.colors.transparentBlack}, 0.12);`
        : "auto;"
    : ""}
      ${({ focused }) => (focused ? `border-bottom-color: transparent;` : "")};

    label::before {
      background-color: ${({ theme, rowType }) => rowType === "body" ? theme.colors.grey15 : ""};
    }
    label::after {
      border-color: ${({ theme, rowType }) => rowType === "body" ? theme.colors.grey10 : ""};
      background-color: ${({ theme, rowType }) => rowType === "body" ? theme.colors.grey15 : ""};
    }
  }

  label::before {
    :active {
      background-color: ${({ theme, rowType }) => rowType === "header" ? theme.colors.grey15 : ""};
    }
  }

  &.disabled,
  &.disabled:active,
  &.disabled:hover {
    background-color: ${({ theme }) => theme.colors.white};
    pointer-events: none;
  }

  &.readonly,
  &.readonly:active,
  &.readonly:hover {
    background-color: ${({ theme }) => theme.colors.white};
    pointer-events: none;
  }

  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  line-height: ${({ theme }) => theme.fontTokens.font12[1]};
  font-weight: ${({ theme, rowType }) => rowType === "header"
    ? theme.fontWeights.medium
    : theme.fontWeights.regular};
`;
